import { type Interpolation } from '@emotion/react';
import { inputSuffixCommonStyle } from '../shared.styles';

export const suffixDropdownStyle: Interpolation = [inputSuffixCommonStyle, {
  borderWidth: '1px 0 1px 1px',
  overflow: 'hidden',
}];
